import { render, staticRenderFns } from "./vehicle-type-add-or-update.vue?vue&type=template&id=38418794"
import script from "./vehicle-type-add-or-update.vue?vue&type=script&lang=js"
export * from "./vehicle-type-add-or-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports